import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PersonalProfileReducer } from '../reducers';

export const selectPersonalProfileFeature = createFeatureSelector<PersonalProfileReducer.PersonalProfileState>(PersonalProfileReducer.featureName);
export const selectPersonal = createSelector(selectPersonalProfileFeature, ({ particular: item }) => item);
export const selectDivision = createSelector(selectPersonalProfileFeature, ({ division }) => division);
export const selectDocuments = createSelector(selectPersonalProfileFeature, ({ documents }) => documents);
